export class Resposta {
    respostaid: number;
    participanteid: number;
    alternativaid: number;
    perguntaid: number;
}